import { Reducer } from 'redux'
import { fromJS } from 'immutable'
import { IMovimientoLayout } from './../models'
import * as TYPES from './../actionTypes'

export const initialState: IMovimientoLayout = fromJS({
  details: {},
  path: {},
  section_title: '',
})

const movimientoLayoutReducer: Reducer<IMovimientoLayout> = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET:
      return state.merge(action.payload)
    case TYPES.CONTENT.REQUEST:
      return state.set('loading', true)
    case TYPES.CONTENT.FAILURE:
      return state.set('error', action.payload)
    case TYPES.CONTENT.FULFILL:
      return state.set('loading', false)
    case TYPES.CONTENT.SUCCESS:
      return state.merge(action.payload)
    default:
      return state
  }
}

export default movimientoLayoutReducer
